import './Footer.scss'

const Footer: React.FC = () => (
  <footer className='footer'>
    <a
      href='https://github.com/sebasrl95/'
      className='link footer__link'
    >
      Created By Sebastian Rojo
    </a>
    <p>&copy; {new Date().getFullYear()} All rights reserved.</p>
  </footer>
)

export default Footer
